<!-- Loading Overlay -->
@if (isLoggingIn) {
  <div class="login-overlay">
    <div class="login-spinner-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="login-spinner-text">Signing in...</p>
    </div>
  </div>
}

@if (isWebView) {
  <!-- ==================== WEB LAYOUT ==================== -->
  <div class="web-landing">

    <div class="web-branding">
      <div class="web-logo">
        <img src="assets/images/NHA_Logo_White_Reverse.png" alt="NHA Logo" />
      </div>
    </div>

    <div class="web-card">
      <div class="web-card-header">
        <h2>Welcome to NHA</h2>
        <p>Select how you're signing in</p>
      </div>
      <div class="web-card-buttons">
        <button type="button" data-testid="login-type-staff-btn" class="web-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Staff')">Sign in as Staff</button>
        <button type="button" data-testid="login-type-parent-btn" class="web-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Parent')">Sign in as Parent</button>
        <button type="button" data-testid="login-type-student-btn" class="web-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Student')">Sign in as Student</button>
      </div>
      <div class="web-card-footer">
        <div class="web-card-help">
          <span>Need help?</span>
          <span>Staff: Submit a Support Ticket <a href="https://support.mynha.com/TechSupport/Details/11" target="_blank" rel="noopener">Here</a></span>
          <span>Parents: Call Parent Relations at <a [href]="parentRelationsPhoneTel">{{parentRelationsPhoneDisplay}}</a></span>
          <small>Mon–Fri · 8:00am – 4:30pm E.T.</small>
        </div>
        <div class="debug-toggle" *ngIf="showLoginDebugToggle">
          <mat-slide-toggle
            [checked]="loginDebugService.isDebugModeEnabled"
            (change)="onDebugModeToggle($event)"
            color="primary">
            <span class="debug-toggle-label">Login Debug Mode</span>
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <div class="web-store-links">
      <a class="web-store-btn" href="https://apps.apple.com/app/id6749588152" target="_blank">
        <i class="web-store-icon web-store-icon--apple"></i>
        <span class="web-store-btn-text">
          <small>Download on the</small>
          <strong>App Store</strong>
        </span>
      </a>
      <a class="web-store-btn" href="https://play.google.com/store/apps/details?id=com.nhaschools.app" target="_blank">
        <i class="web-store-icon web-store-icon--google"></i>
        <span class="web-store-btn-text">
          <small>Get it on</small>
          <strong>Google Play</strong>
        </span>
      </a>
    </div>
  </div>
} @else {
  <!-- ==================== MOBILE LAYOUT ==================== -->
  <div class="mobile-landing">

    <div class="mobile-top">
      <div class="mobile-logo">
        <img src="assets/images/NHA_Logo_White_Reverse.png" alt="NHA Logo" />
      </div>
      <div class="mobile-welcome">
        <h1>Welcome to NHA</h1>
        <p>Sign in to continue</p>
      </div>
    </div>

    <div class="mobile-sheet">
      <span class="mobile-sheet-label">Sign In As</span>
      <div class="mobile-sheet-buttons">
        <button type="button" data-testid="login-type-staff-btn" class="mobile-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Staff')">Staff</button>
        <button type="button" data-testid="login-type-parent-btn" class="mobile-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Parent')">Parent</button>
        <button type="button" data-testid="login-type-student-btn" class="mobile-login-btn btn btn-secondary btn-secondary" (click)="onLoginTypeSelected('Student')">Student</button>
      </div>
      <div class="mobile-help">
        <p>Need help?</p>
        <p>Staff: Submit a Support Ticket <a href="https://support.mynha.com/TechSupport/Details/11" target="_blank" rel="noopener">Here</a></p>
        <p>Parents: Call Parent Relations at <a [href]="parentRelationsPhoneTel">{{parentRelationsPhoneDisplay}}</a></p>
        <small>Mon–Fri, 8:00am – 4:30pm E.T.</small>
      </div>
      @if (capgoBundleVersion) {
        <div class="mobile-version">
          <small>Version: {{capgoBundleVersion}}</small>
        </div>
      }
      <div class="debug-toggle" *ngIf="showLoginDebugToggle">
        <mat-slide-toggle
          [checked]="loginDebugService.isDebugModeEnabled"
          (change)="onDebugModeToggle($event)"
          color="primary">
          <span class="debug-toggle-label">Login Debug Mode</span>
        </mat-slide-toggle>
      </div>
    </div>

  </div>
}
